"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableCell = exports.StyledItemTable = exports.StyledImgSpan = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CalciteThemeProvider = require("calcite-react/CalciteThemeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  white-space: normal;\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ReactVirtualized__Table__headerRow {\n    box-shadow: inset 0 -2px 0 ", ";\n  }\n\n  .ReactVirtualized__Table__sortableHeaderIcon {\n    height: 3em;\n    width: 3em;\n    color: ", ";\n  }\n\n  .ReactVirtualized__Table__headerColumn {\n    height: 40px;\n    box-shadow: inset 0 -2px 0 ", ";\n\n    &.ReactVirtualized__Table__sortableHeaderColumn {\n      justify-content: space-between;\n\n      &:hover {\n        box-shadow: inset 0 -2px 0 ", ";\n      }\n\n      &[aria-sort=\"descending\"],\n      &[aria-sort=\"ascending\"] {\n        &,\n        &:hover {\n          box-shadow: inset 0 -2px 0 ", ";\n        }\n\n        .ReactVirtualized__Table__headerTruncatedText {\n          color: ", ";\n        }\n      }\n    }\n  }\n\n  .ReactVirtualized__Table__row {\n    position: static !important;\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // Calcite theme and Esri colors
var StyledItemTable = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.palette.lightestGray;
}, _CalciteThemeProvider.CalciteTheme.palette.blue, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.lighterBlue;
}, function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return props.theme.palette.blue;
});
exports.StyledItemTable = StyledItemTable;
var StyledTableCell = _styledComponents.default.div(_templateObject2());
exports.StyledTableCell = StyledTableCell;
var StyledImgSpan = _styledComponents.default.span(_templateObject3());
exports.StyledImgSpan = StyledImgSpan;